module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-001.18d07574.jpg";